import type { OnlineRoomRecovery } from "./online-room-recovery.js";
import type { OnlineRoomAuthority } from "./room-protocol.js";

export class OnlineRoomHostLoop {
  #timer: ReturnType<typeof setInterval> | undefined;

  constructor(
    private readonly tickMs: number,
    private readonly authority: () => OnlineRoomAuthority | undefined,
    private readonly recovery: OnlineRoomRecovery,
    private readonly publishState: () => Promise<void>,
    private readonly fail: (error: unknown) => void,
  ) {}

  start(): void {
    this.stop();
    this.#timer = setInterval(() => {
      const authority = this.authority();
      if (!authority) return;
      try {
        if (!this.recovery.canAdvance()) return;
        authority.tick(this.tickMs);
        void this.publishState();
        void this.recovery.hostTick(authority.gameTimeMs);
      } catch (error) {
        this.fail(error);
      }
    }, this.tickMs);
  }

  stop(): void {
    if (this.#timer) clearInterval(this.#timer);
    this.#timer = undefined;
  }
}
